import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT, COLORS } from '../config/constants';
import { Sfx } from '../systems/Sfx';

export class PauseScene extends Phaser.Scene {
  private levelId!: number;

  constructor() {
    super('Pause');
  }

  init(data: { levelId: number }): void {
    this.levelId = data.levelId;
  }

  create(): void {
    this.add.rectangle(GAME_WIDTH / 2, GAME_HEIGHT / 2, GAME_WIDTH, GAME_HEIGHT, 0x000000, 0.55);
    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'ui_panel');

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 100, 'Paused', {
        fontFamily: 'Georgia, serif',
        fontSize: '40px',
        color: '#ffffff'
      })
      .setOrigin(0.5);

    this.createButton(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 10, 'Resume', () => {
      this.scene.stop();
      this.scene.resume('Game');
    });

    this.createButton(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 60, 'Restart', () => {
      this.scene.stop();
      this.scene.stop('Game');
      this.scene.start('Game', { levelId: this.levelId });
    });

    this.createButton(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 130, 'Level Select', () => {
      this.scene.stop();
      this.scene.stop('Game');
      this.scene.start('LevelSelect');
    });

    this.input.keyboard?.on('keydown-ESC', () => {
      Sfx.buttonTap();
      this.scene.stop();
      this.scene.resume('Game');
    });

    this.createSettingsButton();
  }

  private createSettingsButton(): void {
    const x = GAME_WIDTH / 2 + 200;
    const y = GAME_HEIGHT / 2 - 130;
    const button = this.add
      .circle(x, y, 20, 0x000000, 0.3)
      .setStrokeStyle(2, 0xffffff, 0.6)
      .setInteractive({ useHandCursor: true });
    this.add.text(x, y, '⚙', { fontSize: '20px', color: '#ffffff' }).setOrigin(0.5);
    button.on('pointerdown', () => {
      Sfx.buttonTap();
      this.scene.pause();
      this.scene.launch('Settings', { returnTo: 'Pause' });
    });
  }

  private createButton(x: number, y: number, label: string, onClick: () => void): void {
    const button = this.add
      .rectangle(x, y, 220, 56, COLORS.fusionGold, 1)
      .setStrokeStyle(3, COLORS.outline)
      .setInteractive({ useHandCursor: true });
    this.add
      .text(x, y, label, { fontFamily: 'Arial', fontSize: '22px', color: '#2e2a38', fontStyle: 'bold' })
      .setOrigin(0.5);
    button.on('pointerover', () => button.setScale(1.05));
    button.on('pointerout', () => button.setScale(1));
    button.on('pointerdown', () => {
      Sfx.buttonTap();
      onClick();
    });
  }
}
